import React from 'react';
import { motion } from 'framer-motion';

interface LoadingScreenProps {
   message?: string;
   error?: string | null;
   onRetry?: () => void;
}

function LoadingScreen({ message, error, onRetry }: LoadingScreenProps) {
   return (
      <div className="h-screen w-screen flex items-center justify-center bg-ink">
         <div className="relative flex flex-col items-center">
            <motion.div
               className="text-9xl font-display text-pearl"
               initial={{ opacity: 0, scale: 0.5 }}
               animate={{ opacity: 1, scale: 1 }}
               transition={{ duration: 0.5 }}
            >
               Quill Studio
            </motion.div>
            <motion.div
               className="absolute inset-0 text-9xl font-display text-pearl/20 blur-3xl"
               initial={{ opacity: 0 }}
               animate={{ opacity: 0.5 }}
               transition={{ duration: 0.5, delay: 0.2 }}
            >
               Quill Studio
            </motion.div>

            <motion.div
               className="mt-4 text-center font-mono text-sm tracking-widest"
               initial={{ opacity: 0 }}
               animate={{ opacity: 1 }}
               transition={{ duration: 0.5, delay: 0.4 }}
            >
               {error ? (
                  <span className="text-rose">{error}</span>
               ) : (
                  <span className="text-silver">
                     {message ?? 'LOADING YOUR UNIVERSE...'}
                  </span>
               )}
            </motion.div>

            {/* FIX 4: Retry button shown when database connection fails */}
            {error && onRetry && (
               <motion.button
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.3, delay: 0.5 }}
                  onClick={onRetry}
                  className="mt-6 px-6 py-2 bg-amethyst hover:bg-amethyst/80 text-white font-mono text-sm rounded transition-colors"
               >
                  RETRY CONNECTION
               </motion.button>
            )}
         </div>
      </div>
   );
}

export default LoadingScreen;
